/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SERVER_URL } from '../../config';

const propTypes = {
    score: PropTypes.number.isRequired,
    comment: PropTypes.string,
    date: PropTypes.string,
};

class FreelancerReview extends Component {
    goToJob = id => {
        if (this.props.isAgent) {
            window.location = `${SERVER_URL}/job/${id}`;
        }
    };

    render() {
        const maxScore = 5;
        const { score, comment, date, author, jobrequest } = this.props;
        const overlayWidth = (100 * (maxScore - score)) / maxScore;
        return (
            <div
                className="freelancer-review"
                onClick={() => {
                    this.goToJob(jobrequest);
                }}
            >
                <div
                    className="freelancer-review__stars"
                    style={{ transform: `translateX(${overlayWidth / 2}%)` }}
                >
                    <span>
                        <i className="icon icon-star-full" />
                        <i className="icon icon-star-full" />
                        <i className="icon icon-star-full" />
                        <i className="icon icon-star-full" />
                        <i className="icon icon-star-full" />
                    </span>
                    <div
                        className="freelancer-review__stars-overlay"
                        style={{ width: `${overlayWidth}%` }}
                    />
                </div>
                <div className="freelancer-review__comment">{comment}</div>
                <div className="freelancer-review__date">
                    {moment(date).format('DD/MM/YYYY')}{' '}
                    {author ? <span>by {author}</span> : null}
                </div>
                {this.props.isAgent ? (
                    <div className="freelancer-review__date">
                        <span>JR{jobrequest}</span>
                    </div>
                ) : null}
            </div>
        );
    }
}

FreelancerReview.propTypes = propTypes;

export default FreelancerReview;
